'use strict';

(function () {
  var $dropdownOurStoresOption = $('.dropdown-our-stores-option');
  var $dropdownOurStoresMenu = $('.dropdown-our-stores-menu');
  var $dropdownOurStoresControl = $('.dropdown-our-stores-control');
  var $dropdownOurStoresPlaceholder = $('.dropdown-our-stores-placeholder');
  var $findStoreItem = $('.find-store-item');

  var toggleMenu = function () {
    $dropdownOurStoresControl.on('click', function () {
      $dropdownOurStoresMenu.toggleClass('active');
    });
  };

  var filterStores = function (item) {
    $dropdownOurStoresMenu.removeClass('active');

    var id = $(item).data('filter');

    var $current = $('.find-store-item[data-option="' + id + '"]').show();
    $findStoreItem.not($current).hide();
  };

  var titleOptionSelected = function () {
    $dropdownOurStoresOption.on('click', function () {
      $dropdownOurStoresPlaceholder.text($(this).text());

      filterStores($(this));
    });

    return true;
  };

  $(function () {
    toggleMenu();
    titleOptionSelected();
  });
})();
